export default __webpack_public_path__ + "static/media/icon-whatsapp.af2f0051.svg";